import { Routes, Route } from 'react-router-dom';
import { Layout } from '../../components/JuryDashboard/Layout';
import JuryOverview from '../../components/JuryDashboard/JuryDashboardOverview';
import JuryDashboard from '../../components/JuryDashboard/ReviewQueue';

export default function JuryDashPage() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<JuryOverview />} />
        <Route path="review-queue" element={<JuryDashboard />} />
      </Route>
    </Routes>
  );
}
